import { render, staticRenderFns } from "./ListaSignatarios.vue?vue&type=template&id=035c35d4"
import script from "./ListaSignatarios.vue?vue&type=script&lang=js"
export * from "./ListaSignatarios.vue?vue&type=script&lang=js"
import style0 from "./ListaSignatarios.vue?vue&type=style&index=0&id=035c35d4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports